import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class CalculatorValue extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get label() {
    return get(this, '_label.value', '');
  }

  get value() {
    return get(this, '_value.value', '');
  }

  get unit() {
    return get(this, '_unit.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/CalculatorValue.model.js